export const hmplusLimitedReleasesListConstants = {
  HMPLUS_LIMITED_RELEASES_LIST_LOADING: "HMPLUS_LIMITED_RELEASES_LIST_LOADING",
  HMPLUS_LIMITED_RELEASES_LIST_SUCCESS: "HMPLUS_LIMITED_RELEASES_LIST_SUCCESS",
  HMPLUS_LIMITED_RELEASES_LIST_FAILURE: "HMPLUS_LIMITED_RELEASES_LIST_FAILURE",
};
